import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import firebase from 'firebase/compat/app';
import { UsersSnackbarService } from '../../../../../shared/services/users-snackbar/users-snackbar.service';

@Component({
  standalone: false,
  selector: 'lib-remove-mfa',
  templateUrl: './remove-mfa.component.html',
  styleUrls: ['./remove-mfa.component.scss'],
})
export class RemoveMfaComponent implements OnInit {
  localFirebaseUser: firebase.User;
  mfaOption: firebase.auth.MultiFactorInfo;
  reAuthPassword = '';

  removeStage = 1;
  mfaResolver: any;
  reAuthPasswordForm: FormGroup;
  hide = true;

  errMessage = '';

  constructor(
    private dialogRef: MatDialogRef<RemoveMfaComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any,
    private usersSnackbarService: UsersSnackbarService,
  ) {}

  ngOnInit() {
    this.localFirebaseUser = this.data.firebaseUser; // TODO: Doing this to get the right types, can this be done better?
    this.mfaOption = this.data.targetMfaOption;
    this.reAuthPasswordForm = new FormGroup({
      reAuthPassword: new FormControl('', Validators.required),
    });
  }

  async submit() {
    const reAuthCred = firebase.auth.EmailAuthProvider.credential(
      this.localFirebaseUser.email,
      this.reAuthPasswordForm.value.reAuthPassword,
    );

    try {
      await this.localFirebaseUser.reauthenticateWithCredential(reAuthCred);
      await this.localFirebaseUser.multiFactor.unenroll(this.mfaOption);
    } catch (err) {
      switch (err.code) {
        case 'auth/multi-factor-auth-required':
          this.removeStage = 2;
          this.mfaResolver = err.resolver;
          break;

        case 'auth/wrong-password':
          this.errMessage = err.message;
          break;

        default:
          console.log(err);
          this.usersSnackbarService.open('An error ocurred whilst removing this MFA method.');
          this.errMessage = err.message;
          break;
      }
    }
  }

  async mfaSuccess() {
    try {
      await this.localFirebaseUser.multiFactor.unenroll(this.mfaOption);
      this.dialogRef.close({ success: true });
      this.usersSnackbarService.open('Your MFA phone number has been removed successfully');
    } catch (err) {
      console.log(err);
    }
  }
}
